import {
  Box,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import React from "react";
import { HtmlHelpers } from "../../../shared/constants/all-constant";

const columns: GridColDef[] = [
  {
    field: "date",
    headerName: "Recorded At",
  },
  {
    field: "colour",
    headerName: "Colour",
  },
  {
    field: "warmth",
    headerName: "Warmth",
  },
  {
    field: "DorsalisPedis",
    headerName: "Pulse - Dorsalis Pedis",
  },
  {
    field: "PosteriorTibialis",
    headerName: "Pulse - Posterior Tibialis",
  },
  {
    field: "capillaryRefill",
    headerName: "Capillary Refill",
  },
  {
    field: "plantarFlexionActive",
    headerName: "Plantar Flexion - Active",
  },
  {
    field: "plantarFlexionPassive",
    headerName: "Plantar Flexion - Passive",
  },
  {
    field: "dorsiFlexionActive",
    headerName: "Dorsi Flexion - Active",
  },
  {
    field: "dorsiFlexionPassive",
    headerName: "Dorsi Flexion - Passive",
  },
  {
    field: "commonPeroneal",
    headerName: "Common Peroneal",
  },
  {
    field: "TibialSuralPlantar",
    headerName: "Tibial Sural Plantar",
  },
  {
    field: "painScore",
    headerName: "Pain Score",
  },
  {
    field: "swelling",
    headerName: "Swelling",
  },
  {
    field: "bloodLoss",
    headerName: "Blood Loss",
  },
  {
    field: "comments",
    headerName: "Comments",
  },
  {
    field: "initials",
    headerName: "Initials",
  },
];

interface IHistoryDataProps {
  formData: any[];
}

const getDateTime = (item: any) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `${moment(item.date, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY")}
  <br />
  ${HtmlHelpers.FOUR_TIMES_SPACE + HtmlHelpers.FOUR_TIMES_SPACE}
  ${moment(item.date, "DD/MM/YYYY HH:mm").format("HH:mm")}`,
      }}
    />
  );
};

function FormDataHistory(props: IHistoryDataProps) {
  const formedData: any[] = props.formData?.map((item: any, index) => {
    return {
      "Date Time": (
        <React.Fragment>{item.date ? getDateTime(item) : null}</React.Fragment>
      ),
      Colour: item.colour,
      Warmth: item.warmth,
      "Posterior Tibialis": item.pulse?.PosteriorTibialis,
      "Dorsalis Pedis": item.pulse?.DorsalisPedis,
      "Capillary Refill": item.capillaryRefill,
      "Plantar Flexion Active": item.movement?.plantarFlexion?.active,
      "Plantar Flexion Passive": item.movement?.plantarFlexion?.passive,
      "Dorsi Flexion Active": item.movement?.dorsiFlexion?.passive,
      "Dorsi Flexion Passive": item.movement?.dorsiFlexion?.passive,
      "Common Peroneal": item.sensation?.Nerves?.commonPeroneal,
      "Tibial Sural Medial/Lateral Plantar":
        item.sensation?.Nerves?.TibialSuralPlantar,
      "Pain Score": item.painScore,
      Swelling: item.swelling,
      BloodLoss: item.bloodLoss,
      Comments: item.comments,
      "Other Comment": item.commentsDescription,
      Initials: item.initials,
    };
  });
  return (
    <Box sx={{ overflowX: "auto" }}>
      <div style={{ fontSize: "1.1rem" }}>
        <Table size="medium">
          {formedData && formedData.length > 0 ? (
            Object.keys(formedData[0]).map((objectItem, index) => {
              return (
                <TableRow key={index}>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                      backgroundColor: "#fff",
                      minWidth: 200,
                      maxWidth: 200,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <b style={{ fontSize: "1rem" }}>{objectItem}</b>
                  </TableCell>
                  {formedData.map((dataItem: any, index) => {
                    return (
                      <TableCell
                        key={index}
                        sx={{
                          minWidth: 200,
                          maxWidth: 200,
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {Array.isArray(dataItem[objectItem])
                          ? dataItem[objectItem].join(", ")
                          : dataItem[objectItem]}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "200px",
                color: "var(--color-border-model)",
              }}
            >
              No data available.
            </div>
          )}
        </Table>
      </div>
    </Box>
  );
}

export default FormDataHistory;
